import { motion } from 'framer-motion';

const agentConfig: Record<string, { color: string; bg: string; abbr: string }> = {
  'claude-code': { color: '#d97706', bg: 'rgba(217, 119, 6, 0.15)', abbr: 'CC' },
  'cursor': { color: '#06b6d4', bg: 'rgba(6, 182, 212, 0.15)', abbr: 'Cu' },
  'windsurf': { color: '#10b981', bg: 'rgba(16, 185, 129, 0.15)', abbr: 'Ws' },
  'codex': { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.15)', abbr: 'Cx' },
  'copilot': { color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.15)', abbr: 'Cp' },
  'aider': { color: '#ec4899', bg: 'rgba(236, 72, 153, 0.15)', abbr: 'Ai' },
  'cline': { color: '#f97316', bg: 'rgba(249, 115, 22, 0.15)', abbr: 'Cl' },
  'roo-code': { color: '#84cc16', bg: 'rgba(132, 204, 22, 0.15)', abbr: 'Rc' },
  'continue': { color: '#14b8a6', bg: 'rgba(20, 184, 166, 0.15)', abbr: 'Cn' },
  'bolt': { color: '#eab308', bg: 'rgba(234, 179, 8, 0.15)', abbr: 'Bt' },
  'devin': { color: '#a855f7', bg: 'rgba(168, 85, 247, 0.15)', abbr: 'Dv' },
  'replit-agent': { color: '#f43f5e', bg: 'rgba(244, 63, 94, 0.15)', abbr: 'Ra' },
  'lovable': { color: '#f472b6', bg: 'rgba(244, 114, 182, 0.15)', abbr: 'Lv' },
  'v0': { color: '#ffffff', bg: 'rgba(255, 255, 255, 0.08)', abbr: 'V0' },
  'gemini-cli': { color: '#4285f4', bg: 'rgba(66, 133, 244, 0.15)', abbr: 'Gm' },
  'amp': { color: '#22d3ee', bg: 'rgba(34, 211, 238, 0.15)', abbr: 'Am' },
  'opencode': { color: '#a3e635', bg: 'rgba(163, 230, 53, 0.15)', abbr: 'Oc' },
  'kilo-code': { color: '#fb923c', bg: 'rgba(251, 146, 60, 0.15)', abbr: 'Kc' },
  'zed': { color: '#06b6d4', bg: 'rgba(6, 182, 212, 0.15)', abbr: 'Zd' },
  'aide': { color: '#34d399', bg: 'rgba(52, 211, 153, 0.15)', abbr: 'Ad' },
};

const defaultConfig = { color: '#94a3b8', bg: 'rgba(148, 163, 184, 0.15)', abbr: '--' };

interface AgentBadgeProps {
  agentName: string;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export default function AgentBadge({ agentName, size = 'sm', showLabel = true }: AgentBadgeProps) {
  const config = agentConfig[agentName] || defaultConfig;

  const sizeClasses = {
    sm: 'text-[10px] px-2 py-0.5 gap-1',
    md: 'text-xs px-2.5 py-1 gap-1.5',
    lg: 'text-sm px-3 py-1.5 gap-2',
  };

  return (
    <motion.span
      whileHover={{ scale: 1.05 }}
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${sizeClasses[size]}`}
      style={{
        backgroundColor: config.bg,
        color: config.color,
        border: `1px solid ${config.color}22`,
      }}
      title={agentName}
    >
      <span className="leading-none font-bold text-[0.65em] tracking-tight opacity-80">{config.abbr}</span>
      {showLabel && (
        <span className="leading-none">{agentName}</span>
      )}
    </motion.span>
  );
}

export { agentConfig };
